var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.bmdReport
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page bmdReport-page",
            staticStyle: { margin: "0 auto", border: "0px solid #E8E8EC" },
            attrs: { id: "print_bmdReport" },
          },
          [
            _c("div", { staticStyle: { height: "50px" } }),
            _c("div", { staticStyle: { "font-size": "18px" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.model.bmdReport.hospitalName
                      ? _vm.model.bmdReport.hospitalName
                      : ""
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "22px",
                  padding: "20px 0 30px 0",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.bmdReport.reportName
                        ? _vm.model.bmdReport.reportName
                        : "体检报告"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-bottom": "1px solid rgb(14, 14, 14)",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.schoolName
                                  ? _vm.model.bmdReport.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.gradeName
                                  ? _vm.model.bmdReport.gradeName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.className
                                  ? _vm.model.bmdReport.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("编号："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.barCode
                                  ? _vm.model.bmdReport.barCode
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("筛查时间："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.screenTime
                                  ? _vm.model.bmdReport.screenTime
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.name
                                  ? _vm.model.bmdReport.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.sex
                                  ? _vm.model.bmdReport.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年龄："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.bmdReport.age
                                  ? _vm.model.bmdReport.age
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "table",
                  width: "100%",
                  "line-height": "25px",
                  "text-align": "left",
                  "margin-left": "20px",
                  "margin-top": "20px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "table-cell",
                      width: "50%",
                      "font-size": "15px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "33%", "font-size": "15px" } },
                        [_vm._v("SOS声速")]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.model.bmdReport.sosSpeed
                              ? _vm.model.bmdReport.sosSpeed
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "33%", "font-size": "15px" } },
                        [_vm._v("同龄百分比")]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.model.bmdReport.sameAge
                              ? _vm.model.bmdReport.sameAge
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "33%", "font-size": "15px" } },
                        [_vm._v("Z-SCORE值")]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.model.bmdReport.zscore
                              ? _vm.model.bmdReport.zscore
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "33%", "font-size": "15px" } },
                        [_vm._v("Z-SCORE指示")]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.model.bmdReport.zscoreIndicate
                              ? _vm.model.bmdReport.zscoreIndicate
                              : ""
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "table-cell",
                      width: "50%",
                      "font-size": "15px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "33%", "font-size": "15px" } },
                        [_vm._v("成人百分比")]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.model.bmdReport.adult
                              ? _vm.model.bmdReport.adult
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "33%", "font-size": "15px" } },
                        [_vm._v("T-SCORE值")]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.model.bmdReport.tscore
                              ? _vm.model.bmdReport.tscore
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        { staticStyle: { width: "33%", "font-size": "15px" } },
                        [_vm._v("T-SCORE指示")]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.model.bmdReport.tscoreIndicate
                              ? _vm.model.bmdReport.tscoreIndicate
                              : ""
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "textCenter",
                staticStyle: { "text-align": "center" },
              },
              [_vm._v("结果图示")]
            ),
            _vm._m(0),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "30px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(1),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.bmdReport.summary
                                    ? _vm.model.bmdReport.summary
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "table",
          width: "100%",
          "text-align": "center",
          "margin-top": "10px",
          "border-bottom": "1px solid rgb(143, 143, 143)",
          "padding-bottom": "30px",
        },
      },
      [
        _c("div", {
          staticStyle: {
            "text-align": "center",
            width: "430px",
            height: "300px",
            "margin-left": "20%",
          },
          attrs: { id: "boneLineChart" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "23px", "font-weight": "bold" } }, [
        _vm._v("筛查小结"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }